import React, { useEffect, useState } from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { SidebarData } from './SidebarData';
import './Navbar.css';
import { IconContext } from 'react-icons';
import * as IoIcons from 'react-icons/io';

//firebase imports
import {  } from '@firebase/firestore';
import { collection, query, where, getDocs, getFirestore, limit } from "firebase/firestore";
import { getAuth, onAuthStateChanged} from "firebase/auth";
import {
    initializeApp
} from "firebase/app";

//firebase config
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBqU42lAjLn0NUdTEwAexRmyt3Bs333g0I",
  authDomain: "expensor-78ad1.firebaseapp.com",
  projectId: "expensor-78ad1",
  storageBucket: "expensor-78ad1.appspot.com",
  messagingSenderId: "685316790253",
  appId: "1:685316790253:web:79dcd75c79f9197fe439e4",
  measurementId: "G-LC26DDDV3H"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
//authentication
const auth = getAuth(app);
//state of log in or not
const db = getFirestore();

function Navbar() {

  const [sidebar, setSidebar] = useState(false);
  const [groups, setGroups] = useState([]);
  const [groupsLoaded, setGroupsLoaded] = useState(false);



  const hideSidebar = () => setSidebar(false);
  const [signedIn, setSignedIn] = useState(false);

 
   useEffect(() => {

     onAuthStateChanged(auth, (user) => {
       if (user !== null) {
         setSignedIn(true);
       }

     });


     if (auth.currentUser !== null) {
       setSignedIn(true);
     } else {
       setSignedIn(false);
     }

     
     getCurrentUserGroups();

   }, [signedIn, groups, groupsLoaded]);

  //hiding sidebar when user click anywhere other than the sidebar. //listener gets called to ofthen
  window.addEventListener('click', (e) => {
    if (e.target !== document.getElementsByClassName('dropDownPointerDown')[0] && e.target !== document.getElementsByClassName('dropDownPointerLeft')[0] && e.target.nodeName !== 'svg' && e.target.nodeName !== 'path') {
      hideSidebar();
    }
  });

  if(groupsLoaded){
    return (
      <div className="navbar-complete">
        <IconContext.Provider value={{ color: '#fff' }}>

          <div className='navbar'>
            {signedIn ? <Link to='#' className='menu-bars'>
              <FaIcons.FaBars onClick={showSidebar} /></Link> :
              <div></div>}

            {/* <Link to='#' className='menu-bars'>
            <FaIcons.FaBars onClick={showSidebar} /></Link> */}

          </div>

          <div className="page-title">
            Expensor
          </div>

          <div className="home-logo">

            {signedIn ? <Link to='/'><AiIcons.AiFillHome /></Link> :
              <Link to=''></Link>}

          </div>



          <nav className={sidebar ? 'nav-menu active' : 'nav-menu'}>
            <ul className='nav-menu-items' >
              <li className='navbar-toggle' onClick={showSidebar}>
                <Link to='#' className='menu-bars'>
                  <AiIcons.AiOutlineClose />
                </Link>
              </li>
              <li onClick={goToLastVisited} className='nav-text'>
                <p className='pExpensesLink'>
                  <FaIcons.FaCartPlus />
                  <span>Expenses</span>
                </p>
              </li>
              <li className='nav-text'>
                <Link to='/groups' >
                  <IoIcons.IoIosPaper />
                  <span>Groups</span>
                </Link>
                <ul>
                  <FaIcons.FaAngleRight className='dropDownPointer dropDownPointerLeft' size={22} onClick={toggleGroup} />
                  <FaIcons.FaAngleDown className='dropDownPointer dropDownPointerDown' size={22} onClick={toggleGroup} />
                  <div className='groupDropdown' >
                    {groups.map((group, index) => {
                      return (
                        <li key={index} className='nav-sub-text'><a style={{ padding: '0.3rem', fontSize: 'smaller', width: '100%', paddingRight: '1.5rem', paddingLeft: '1.5rem' }} className='noStyleLink' href={`/expenses/${group.key}`} >{group.name}</a></li>
                      )
                    })
                    }
                  </div>
                </ul>
              </li>
              {SidebarData.map((item, index) => {
                return (
                  <li key={index} className={item.cName}>
                    <Link to={item.path}>
                      {item.icon}
                      <span>{item.title}</span>
                    </Link>
                  </li>
                );
              })}
              <p className='errorMessageNavbar' style={{ color: 'red' }}></p>
            </ul>

          </nav>
        </IconContext.Provider>

      </div>
    );
  }
else{
    return (
      <div className="navbar-complete">
        <IconContext.Provider value={{ color: '#fff' }}>

          <div className='navbar'>
            {signedIn ? <Link to='#' className='menu-bars'>
              <FaIcons.FaBars onClick={showSidebar} /></Link> :
              <div></div>}

            {/* <Link to='#' className='menu-bars'>
            <FaIcons.FaBars onClick={showSidebar} /></Link> */}

          </div>

          <div className="page-title">
            Expensor
          </div>

          <div className="home-logo">

            {signedIn ? <Link to='/'><AiIcons.AiFillHome /></Link> :
              <Link to=''></Link>}

          </div>



          <nav className={sidebar ? 'nav-menu active' : 'nav-menu'}>
            <ul className='nav-menu-items' >
              <li className='navbar-toggle' onClick={showSidebar}>
                <Link to='#' className='menu-bars'>
                  <AiIcons.AiOutlineClose />
                </Link>
              </li>
              <li onClick={goToLastVisited} className='nav-text'>
                <p className='pExpensesLink'>
                  <FaIcons.FaCartPlus />
                  <span>Expenses</span>
                </p>
              </li>
              <li className='nav-text'>
                <Link to='/groups' >
                  <IoIcons.IoIosPaper />
                  <span>Groups</span>
                </Link>
              </li>
              {SidebarData.map((item, index) => {
                return (
                  <li key={index} className={item.cName}>
                    <Link to={item.path}>
                      {item.icon}
                      <span>{item.title}</span>
                    </Link>
                  </li>
                );
              })}
              <p className='errorMessageNavbar' style={{ color: 'red' }}></p>
            </ul>

          </nav>
        </IconContext.Provider>

      </div>
    );
}

  function showSidebar(){
    setSidebar(!sidebar);
  }

  function toggleGroup() {
    const block = document.getElementsByClassName('groupDropdown')[0];
    if (block.style.display === "block") {
      block.style.display = "none";
      document.getElementsByClassName('dropDownPointerDown')[0].style.display = "block";
      document.getElementsByClassName('dropDownPointerLeft')[0].style.display = "none";
    }
      else{
        block.style.display = "block";
      document.getElementsByClassName('dropDownPointerDown')[0].style.display = "none";
      document.getElementsByClassName('dropDownPointerLeft')[0].style.display = "block";
    }
  }

  async function getCurrentUserGroups(){
    let getGroupsFromFirebase=[]
    try {
      if (auth.currentUser !== null) {
        const q = query(collection(db, "Groups"), where("members", "array-contains", auth.currentUser.uid), where("isDeleted", "==", false), limit(4));

        //vragen docent const q2 = query(collection)

        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          getGroupsFromFirebase.push({ ...doc.data(), key: doc.id }); // ... => spreidinsoperator
        });

        setGroups(getGroupsFromFirebase);
        setGroupsLoaded(true);
      }
    } catch (error) {
      document.getElementsByClassName('errorMessageNavbar')[0].innerHTML = "Could not retrieve your groups: " + error.message;
    }
  }

  async function goToLastVisited() {
    let lastGroup = null;
    try {
      if (auth.currentUser !== null) {
        const userDocs = query(collection(db, "Users"), where('userId', '==', auth.currentUser.uid));
        const userDocsSnapshot = await getDocs(userDocs);

        await userDocsSnapshot.forEach(doc => {
          lastGroup = doc.data().lastVisitedGroup;
        });
      }
      if (lastGroup != null) {
        window.location.href = `/expenses/${lastGroup}`;
      }
      else {
        document.getElementsByClassName('noLastVisitedGroup')[0].innerHTML = "You haven't visited any groups yet.";
      }
    } catch (error) {
      document.getElementsByClassName('errorMessageNavbar')[0].innerHTML = "Could not go to last visited group:" + error.message;
    }
  }
}

export default Navbar;
